module.exports = __webpack_public_path__ + "img/color_block_4.8cbcd218.svg";